export default __webpack_public_path__ + "static/media/i33.aaed4cbe.jpeg";